import React from "react";

const PrivacyPolicy = () => {
  return (
    <div>
      <div className="container">
        <div className="privacy_text">
          <h1>Privacy Policy</h1>
          <h2>
            Effective Date: <span>01/24/2025</span>
          </h2>

          <p>
            <b>Spotlifts</b> is committed to protecting your privacy. This
            Privacy Policy explains how we collect, use, disclose, and safeguard
            your information when you use our gym management and fitness
            tracking application (Spotlifts) and related services. By using the
            App, you agree to the terms of this Privacy Policy.
          </p>

          {/* ------------------- Privacy Choices ------------------- */}

          <h2>1. Your Privacy Choices</h2>

          <h4>Data Deletion</h4>
          <p>
            You may request the deletion of your personal information by
            contacting us at the email provided below. We will respond to all
            verified requests within 30 days. Please note that we may retain
            certain data as required by law or for legitimate gym operational
            and business purposes.
          </p>

          {/* ------------------- Facebook Required Section ------------------- */}

          <h2>2. Data Deletion Instructions (Facebook Login)</h2>

          <p>
            If you have connected your Facebook account with <b>Spotlifts</b>{" "}
            and wish to delete the data obtained through Facebook Login, you may
            do so using one of the following methods:
          </p>

          <div className="least">
            <ul>
              <li>
                Send an email to{" "}
                <a href="mailto:support@spotlifts.com">support@spotlifts.com</a>{" "}
                with the subject line <b>“Facebook Data Deletion Request”</b>.
                Your request will be processed within 30 days.
              </li>

              <li>
                You may also remove Spotlifts access directly from your Facebook
                account:
                <ol>
                  <li>Open Facebook and go to Settings & Privacy.</li>
                  <li>
                    Click on <b>Settings</b> → <b>Apps and Websites</b>.
                  </li>
                  <li>
                    Locate <b>Spotlifts</b> and click <b>Remove</b>.
                  </li>
                </ol>
              </li>
            </ul>
          </div>

          {/* ------------------- Contact Section ------------------- */}

          <h2>3. Contact Us</h2>

          <p>
            If you have any questions, concerns, or requests related to this
            Privacy Policy or your personal data, please contact us:
          </p>

          <p>
            📧 Email:{" "}
            <a href="mailto:support@spotlifts.com">support@spotlifts.com</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
